import axios from "axios";
import { tagRecording } from "~/utils/hotjarTracking";

export const useLocalSettingsStore = defineStore("localSettings", () => {
    const config = useRuntimeConfig();

    const settings = useSlugLocalStorage("localSettings-settings", {
        lastSeen: Date.now().toString(),
        locale: config.public.locale,
    });

    watchEffect(() => {
        axios.defaults.headers.common["Accept-Language"] =
            settings.value.locale;

        tagRecording(["lang-" + settings.value.locale]);
    });

    return toRefs(settings.value);
});
